import { SentimentBgImage, InfoIcon } from 'assets'
import React, { useEffect, useState } from 'react'
import ProgressBar from 'progressbar.js'
import { useSelector } from 'react-redux'

function InSentimentScore() {
   const [isSentimentScore, setIsSentimentScore] = useState(true)
   // const videoRedux = useSelector((state) => state.videoRedux)
   // const { videoDetails: videoDetailsData, videoRiskScore } = videoRedux

   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { loading, postDetails } = instagramDashboardData

   const [globalSentimentScore, setGlobalSentimentScore] = useState(null)
   const [globalRiskScore, setGlobalRiskScore] = useState(null)

   useEffect(() => {
      if (isSentimentScore && postDetails?.global_sentiment_score) {
         let rr = postDetails?.sentiment_score - postDetails?.global_sentiment_score
         setGlobalSentimentScore(rr.toFixed(1))
      } else {
         setGlobalSentimentScore(null)
      }

      return () => {}
   }, [isSentimentScore, postDetails])

   const getText = (value) => {
      if (isSentimentScore) {
         return `<div class='text-center'> <span class='score-value text-white'> ${postDetails?.sentiment_score} </span>   </div>`
      }
   }

   useEffect(() => {
      const bar = new ProgressBar.SemiCircle('#chart-container', {
         strokeWidth: 15,
         trailColor: '#FFFFFF4D',
         trailWidth: 15,
         easing: 'easeInOut',
         duration: 1400,
         svgStyle: null,
         text: {
            value: '',
            alignToBottom: false,
            className: 'progressbar__label at-dashboard'
         },
         step: (state, bar) => {
            bar.path.setAttribute('stroke', state.color)
            bar.path.setAttribute('stroke', 'url(#myGradient)') // Reference to the gradient
            bar.path.setAttribute('fill', 'none') // No fill for the stroke
            const value = Math.round(bar.value() * 100)
            if (value === 0) {
               bar.setText('')
            } else {
               bar.setText(getText(value))
            }
            bar.text.style.color = 'state.color'
         }
      })
      if (bar) {
         if (isSentimentScore) {
            if (postDetails?.sentiment_score) {
               bar.animate(postDetails?.sentiment_score / 100)
            } else {
               bar.animate(0)
            }
         }
      }

      return () => {
         bar.destroy() // Cleanup on component unmount
      }
   }, [isSentimentScore, postDetails])

   return (
      <div
         style={{
            backgroundImage: `url(${SentimentBgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
         }}>
         <div className="card">
            <div className="sentiment-score-section">
               <div className="d-flex justify-content-between align-items-center">
                  <h4 className="channel-score-title">Sentiment Score</h4>
               </div>
               {/* <p className="at-text-light mt-2 at-font-14">Last updated 2 min ago</p> */}

               <div className="progress-bar-section">
                  <svg
                     width="100%"
                     height="100%"
                     xmlns="http://www.w3.org/2000/svg"
                     style={{ position: 'absolute' }}>
                     <defs>
                        <linearGradient
                           id="myGradient"
                           x1="0%"
                           y1="0%"
                           x2="100%"
                           y2="100%"
                           gradientTransform="rotate(61.59)">
                           <stop offset="0%" stopColor="#98FF23" />
                           <stop offset="99.45%" stopColor="#27D089" />
                        </linearGradient>
                     </defs>
                     {/* <rect width="100%" height="100%" fill="url(#myGradient)" /> */}
                  </svg>
                  <div id="chart-container"></div>
                  <div className="progress-bar-labels">
                     <span className="progress-label start">0</span>
                     <span className="progress-label end">100</span>
                  </div>
               </div>

               {postDetails?.global_sentiment_score ? (
                  <div
                     className={`sentiment-desc ${
                        globalSentimentScore >= 0 ? '' : 'negative-line'
                     }`}>
                     <span className="at-text-light video-sentiment-text">
                        This post has {globalSentimentScore} points{' '}
                        {globalSentimentScore >= 0 ? 'higher ' : 'lower '}
                        than the sentiment score
                     </span>
                  </div>
               ) : null}
            </div>
         </div>
      </div>
   )
}

export default InSentimentScore
